import {
    TestingDetailFetchFailureAction,
    TestingDetailFetchRequestAction,
    TestingDetailFetchSuccessAction,
    TESTING_DETAIL_FETCH_FAILURE,
    TESTING_DETAIL_FETCH_REQUEST,
    TESTING_DETAIL_FETCH_SUCCESS,
} from 'mk2/apps/testings/containers/TestingDetail/TestingDetail.actions';
import { errorMessage } from 'mk2/reducers/errorMessage';
import { initialState as initialInfiniteListState, State as InfiniteListState } from 'mk2/reducers/infiniteList';
import { loadingState, LoadingState } from 'mk2/reducers/loadingState';
import { Reducer } from 'redux';

export const initialPostsState: InfiniteListState = initialInfiniteListState;

export interface TestingDetailState {
    testingId: number;
    testersPostsIds: number[];
    errorMessage: string;
    loadingState: LoadingState;
}

export const initialTestingDetailState: TestingDetailState = {
    testingId: null,
    testersPostsIds: [],
    errorMessage: null,
    loadingState: LoadingState.INIT,
};

declare type TestingDetailReducerAction =
    TestingDetailFetchRequestAction
    | TestingDetailFetchSuccessAction
    | TestingDetailFetchFailureAction;

const testingDetailReducer: Reducer<TestingDetailState> = (state = initialTestingDetailState, action: TestingDetailReducerAction) => {
    switch (action.type) {
        case TESTING_DETAIL_FETCH_SUCCESS:
            return {
                ...state,
                testingId: action.response.result.testing,
                testersPostsIds: action.response.result.testersPosts,
                loadingState: loadingState(undefined, action),
                errorMessage: errorMessage(undefined, action),
            };

        case TESTING_DETAIL_FETCH_REQUEST:
        case TESTING_DETAIL_FETCH_FAILURE:
            return {
                ...state,
                loadingState: loadingState(undefined, action),
                errorMessage: errorMessage(undefined, action),
            };

        default:
            return state;
    }
};

export interface TestingsDetailState {
    [testingHashtag: string]: TestingDetailState;
}

declare type TestingsDetailReducerAction =
    TestingDetailFetchRequestAction
    | TestingDetailFetchSuccessAction
    | TestingDetailFetchFailureAction;

const testingsDetailReducer: Reducer<TestingsDetailState> = (state: TestingsDetailState = {}, action: TestingsDetailReducerAction) => {
    switch (action.type) {
        case TESTING_DETAIL_FETCH_SUCCESS:
        case TESTING_DETAIL_FETCH_REQUEST:
        case TESTING_DETAIL_FETCH_FAILURE:
            return {
                ...state,
                [action.testingHashtag]: testingDetailReducer(state[action.testingHashtag], action),
            };

        default:
            return state;
    }
};

export default testingsDetailReducer;
